import theme from './theme'
import customCookeBox from './customCookeBox'

const constants = {
  theme,
  customCookeBox,
}

export default constants
